import { useNotifyChange, useOnChange } from 'hooks/useChangeSignal';

// A company was created (slide-over add_company): the list of the companies
// reads them again.
export const COMPANIES_CHANGED = 'companies_changed';

export const useNotifyCompaniesChanged = () => useNotifyChange(COMPANIES_CHANGED);

const useCompaniesChanged = (onChanged) => useOnChange(COMPANIES_CHANGED, onChanged);

export default useCompaniesChanged;
